<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="600px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <el-form-item label="所属店铺：" prop="tenant">
        <tenantSelector
          size="small"
          ref="tenantSelector"
          v-model="dataForm.tenant"
        />
      </el-form-item>
      <el-form-item label="时间范围：" prop="dateTime">
        <dateOptionSelector
          size="small"
          v-model="dataForm.dateTime"
          ref="dateOptionSelector"
          :options="dateOptions"
        />
      </el-form-item>
      <!-- <el-form-item label="订单渠道：" prop="channel">
        <enumSelector
          ref="enumSelector"
          :options="config.channels"
          v-model="dataForm.channel"
        />
      </el-form-item> -->
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit()">下载评价</el-button>
        <el-button type="info" @click="handleClose()">关闭窗口</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
      <script>
import { syncComments } from "@/api/bussiness/commet";
import dateOptionSelector from "@/components/dateOptionSelector";
import enumSelector from "@/components/enumSelector";
import tenantSelector from "@/components/tenantSelector";
export default {
  components: {
    enumSelector,
    dateOptionSelector,
    tenantSelector,
  },
  data() {
    return {
      dateOptions: [{ value: "comment", name: "评价时间" }],
      dataForm: {
        tenant: "",
       // channel: "DianPing",
        dateTime: {
          dateType: "comment",
          date: [],
        },
      },
      formRules: {
        tenant: [
          { required: true, message: "请选择店铺", trigger: "change" },
        ],
        dateTime:[{ required: true, message: "请选择时间范围", trigger: "change" },],
      },
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    show() {
      this.drawerTitle = "获取评价";
      this.drawerVisible = true;
    },
    handleClose() {
      this.drawerVisible = false;
    },
    handleSubmit() {
      let filters = {
        tenant: this.dataForm.tenant ? this.dataForm.tenant.Key : "",
        channel: this.dataForm.channel,
        beginDate:
          this.dataForm.dateTime.date.length > 0
            ? this.dataForm.dateTime.date[0]
            : "",
        endDate:
          this.dataForm.dateTime.date.length > 1
            ? this.dataForm.dateTime.date[1]
            : "",
      };
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          syncComments(filters).then((response) => {
            if (response) {
              this.drawerVisible = false;
              this.msg.successMsg("操作完成！");
              this.$emit("update");
            }
          });
        }
      });
    },
  },
  mounted() {},
};
</script>
      <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>